import { render } from "./LeafletMap.vue?vue&type=template&id=12839996&scoped=true"
import script from "./LeafletMap.vue?vue&type=script&lang=js"
export * from "./LeafletMap.vue?vue&type=script&lang=js"

import "./LeafletMap.vue?vue&type=style&index=0&id=12839996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12839996"]])

export default __exports__